import { render } from "./PercentageIcon.vue?vue&type=template&id=9e4e3d06"
import script from "./PercentageIcon.vue?vue&type=script&lang=ts"
export * from "./PercentageIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script